import React from "react";
import { BadgeCheck } from "lucide-react";
import { cn } from "@/lib/utils";

/** Staff Messaging V1 — marks a message or thread as official platform communication from
 *  Startup Otter, so a member can tell it apart from an ordinary member's profile. */
export function OfficialBadge({ className, label = "Official", testId = "official-badge" }) {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1 rounded-full bg-teal-50 px-2 py-0.5 text-[11px] font-[620] text-teal-700 ring-1 ring-teal-100",
        className,
      )}
      data-testid={testId}
      title="Official message from Startup Otter"
    >
      <BadgeCheck className="h-3 w-3" /> {label}
    </span>
  );
}
